import { useEffect } from 'react'
import client from 'api/client'
import { useRootStore } from 'stores/RootStore'

export type FlaggedFeature =
  | 'microsoft_graph_calendar_integration'
  | 'new_left_rail'
  | 'post_prompts'
  | 'scheduled_reviews'
  | 'version_control_mode'
  | 'cable_debug_websocket'
  | 'anycable_tp_client'
  | 'turn_into_distribute'
  | 'new_inline_format_bar'
  | 'show_release_info'
  | 'new_table_menu'
  | 'api_keys'
  | 'usage_based_pricing'
  | 'admin_templates'
  | 'recents_home_new'
  | 'mystic'
  | 'image_revisions'
  | 'tiktok_integration'
  | 'youtube_integration'
  | 'mobile_publishing'
  | 'writer_multiplanning'
  | 'templates_page_v2'
  | 'product_tours_2025'
  | 'video_wizards'
  | 'audience_metrics'
  | 'simplified_wizards'
  | 'mobile_redesign_wizard_A1'
  | 'mobile_redesign_wizard_B'
  | 'mobile_redesign_wizard_C'
  | 'mobile_redesign_wizard_D'
  | 'mobile_redesign_wizard_E'
  | 'mobile_redesign_wizard_F'
  | 'mobile_redesign_wizard_G'
  | 'mobile_redesign_wizard_H1'
  | 'mobile_redesign_wizard_I'
  | 'mobile_redesign_wizard_J'
  | 'mobile_redesign_wizard_K1'
  | 'mobile_redesign_wizard_M1'
  | 'saved_drafts'
  | 'blog_metadata_v2'
  | 'superadmin_templates'
  | 'social_desktop_wizards_flow_A2'
  | 'social_desktop_wizards_flow_B'
  | 'social_desktop_wizards_flow_C'
  | 'mobile_redesign_wizard_A1_layout_customisation'
  | 'new_registration'
  | 'integrations_banner'
  | 'instagram_captions_channel'
  | 'mobile_redesign_wizard_Z1'
  | 'mobile_redesign_wizard_Z2'
  | 'designer_resize'
  | 'brand_kit_migration'
  | 'wizards_tour'
  | 'new_desktop_image_gen'
  | 'mailchimp_integration'
  | 'wix_blog_integration'
  | 'new_wix_oauth'
  | 'shopify_integration'
  | 'april_sale'
  | 'brand_profile_playground'
  | 'gpt_image_one'
  | 'new_image_menu'
  | 'website_crawler'
  | 'templates_mix'
  | 'google_integration'
  | 'google_business_profile_integration'
  | 'virtual_marketer_upgrade'
  | 'designer_chat_assistant'
  | 'brand_kit_add_more_images'
  | 'vm_onboarding_add_more_images'
  | 'brand_profile_enhancement'
  | 'enhancement_preview'
  | 'calendar_full_screen_preview'
  | 'brand_kit_website_list_view'
  | 'brand_kit_images_sorting'
  | 'brand_kit_expanded_context_tab'
  | 'ab_test_force_a'
  | 'ab_test_force_b'
  | 'autopilot_early_bird_9_26'
  | 'autopilot_early_bird_9_29'
  | 'cross_post_groups'
  | 'optimized_onboarding'
  | 'autopilot_registration_stale_client_modal'
  | 'monotype_fonts'
  | 'scheduled_posts_v3'
  | 'use_scheduled_posts_for_mailchimp'
  | 'autopilot_mobile_onboarding'
  | 'blog_platform_onboarding_branding'
  | 'external_integrations_heartbeat'
  | 'onboarding_no_website_flow'
  | 'calendar_target_status'
  | 'generation_credits'
  | 'brain_playground'
  | 'campaigns_launch'
  | 'native_brand_kit_brand_profile'
  | 'native_brand_kit_content_preferences'
  | 'native_brand_kit_images_videos'
  | 'native_brand_kit_source_materials'
  | 'native_brand_kit_styles_voice'
  | 'system_redesign'
  | 'brain_channel_insights'
  | 'brain_strategic_recommendations_debug'
  | 'ap_mobile_web_calendar'
  | 'ap_mobile_web_calendar_swipe'
  | 'white_label'
  | 'youtube_metrics'
  | 'batch_campaign_regeneration'
  | 'pioneer_credits'
  | 'calendar_refetch_pending_schedules'
  | 'batch_create_campaigns'
  | 'ads_budget_pacing_pills'
  | 'ads_videos'
  | 'ads_onboarding'
  | 'diversity_preferences'
  | 'onboarding_add_voice_page'
  | 'force_starter_plan_onboarding'
  | 'content_plan_redesign'
  | 'generation_playground'
  | 'new_churn_flow'
  | 'calendar_review_button'
  | 'ads_background_publishing'
  | 'ai_image_generation_credits'
  | 'plagiarism_credits'
  | 'ads_credits'
  | 'nextgen_content_preferences'
  | 'icp_block'
  | 'blaze_studio_live'
  | 'create_content_modal_v2'
  | 'seo_relevance_plan'
  | 'map_pack'
  | 'map_pack_post_gen'
  | 'map_pack_live_updates'
  | 'map_pack_heatmap'
  | 'map_pack_heatmap_prefetch'
  | 'map_pack_reviews'
  | 'vertical_plan_length'
  | 'facebook_stories'
  | 'start_subscription_after_onboarding'
  | 'compact_calendar_view'
  | 'mobile_content_plan'
  | 'google_ads_integration'
  | 'dynamic_captions'
  | 'global_dynamic_captions'
  | 'ads_creative_refresh'
  | 'meta_ads_creative_fatigue'
  | 'meta_ads_v3'
  | 'meta_ads_weekly_report'
  | 'fast_website_scraping'
  | 'learning_loop_playground'
  | 'learnings_screen'
  | 'location_tagging_x'
  | 'location_tagging_linkedin'
  | 'user_tagging_x'
  | 'user_mentioning_x'
  | 'user_mentioning_linkedin'
  | 'location_tagging_facebook'
  | 'location_tagging_instagram'
  | 'user_mentioning_facebook'
  | 'user_mentioning_instagram'
  | 'user_tagging_instagram'
  | 'post_content_types'
  | 'merged_brand_plan_settings'
  | 'dfy_login_cta'
  | 'dfy_home_cta'
  | 'dfy_canceled_cta'
  | 'dfy_product_pages'
  | 'auto_replies'
  | 'generation_v2'
  | 'billing_upgrades_and_add_ons'
  | 'billing_credits_and_plan_card'
  | 'activation_integration_modal'
  | 'duplicate_campaigns'
  | 'home_v4'
  | 'content_type_discovery'
  | 'strict_brand_control'
  | 'calendar_v2'
  | 'campaign_filter'
  | 'strategies_discount'
  | 'dfy_unscheduled_posts'
  | 'zapier_v2'
  | 'reputation_management'
  | 'reputation_customer_support_voice'
  | 'reputation_social_listening'
  | 'reputation_review_requests'
  | 'seo_aeo'
  | 'aeo_snapshots'
  | 'video_voiceover_captions'
  | 'editable_captions'
  | 'paid_search'
  | 'extract_layers'
  | 'competitor_analysis'
  | 'ai_avatar_videos'
  | 'local_service_ads'
  | 'strategies_migration'
  | 'a2p_compliance'
  | 'facebook_graph_api_v23'
  | 'hide_booking'
  | 'hide_meta_strategy'
  | 'dfy_copy_duplicate'

export const ActiveFlags: FlaggedFeature[] = [
  'microsoft_graph_calendar_integration',
  'local_service_ads',
  'new_left_rail',
  'post_prompts',
  'scheduled_reviews',
  'version_control_mode',
  'anycable_tp_client',
  'cable_debug_websocket',
  'show_release_info',
  'api_keys',
  'admin_templates',
  'recents_home_new',
  'mystic',
  'image_revisions',
  'tiktok_integration',
  'youtube_integration',
  'mobile_publishing',
  'writer_multiplanning',
  'templates_page_v2',
  'product_tours_2025',
  'video_wizards',
  'audience_metrics',
  'simplified_wizards',
  'mobile_redesign_wizard_A1',
  'mobile_redesign_wizard_B',
  'mobile_redesign_wizard_C',
  'mobile_redesign_wizard_D',
  'mobile_redesign_wizard_E',
  'mobile_redesign_wizard_F',
  'mobile_redesign_wizard_G',
  'mobile_redesign_wizard_H1',
  'mobile_redesign_wizard_I',
  'mobile_redesign_wizard_J',
  'mobile_redesign_wizard_K1',
  'mobile_redesign_wizard_M1',
  'saved_drafts',
  'blog_metadata_v2',
  'social_desktop_wizards_flow_A2',
  'social_desktop_wizards_flow_B',
  'social_desktop_wizards_flow_C',
  'mobile_redesign_wizard_A1_layout_customisation',
  'new_registration',
  'instagram_captions_channel',
  'mobile_redesign_wizard_Z1',
  'mobile_redesign_wizard_Z2',
  'designer_resize',
  'brand_kit_migration',
  'wizards_tour',
  'new_desktop_image_gen',
  'mailchimp_integration',
  'april_sale',
  'brand_profile_playground',
  'gpt_image_one',
  'new_image_menu',
  'website_crawler',
  'templates_mix',
  'google_integration',
  'google_business_profile_integration',
  'virtual_marketer_upgrade',
  'designer_chat_assistant',
  'brand_kit_add_more_images',
  'vm_onboarding_add_more_images',
  'brand_profile_enhancement',
  'enhancement_preview',
  'calendar_full_screen_preview',
  'brand_kit_website_list_view',
  'brand_kit_images_sorting',
  'brand_kit_expanded_context_tab',
  'wix_blog_integration',
  'new_wix_oauth',
  'ab_test_force_a',
  'ab_test_force_b',
  'autopilot_early_bird_9_26',
  'autopilot_early_bird_9_29',
  'cross_post_groups',
  'optimized_onboarding',
  'autopilot_registration_stale_client_modal',
  'monotype_fonts',
  'scheduled_posts_v3',
  'use_scheduled_posts_for_mailchimp',
  'autopilot_mobile_onboarding',
  'blog_platform_onboarding_branding',
  'external_integrations_heartbeat',
  'onboarding_no_website_flow',
  'calendar_target_status',
  'generation_credits',
  'campaigns_launch',
  'native_brand_kit_brand_profile',
  'native_brand_kit_content_preferences',
  'native_brand_kit_images_videos',
  'native_brand_kit_source_materials',
  'native_brand_kit_styles_voice',
  'system_redesign',
  'brain_channel_insights',
  'brain_strategic_recommendations_debug',
  'ap_mobile_web_calendar',
  'ap_mobile_web_calendar_swipe',
  'white_label',
  'youtube_metrics',
  'batch_campaign_regeneration',
  'pioneer_credits',
  'calendar_refetch_pending_schedules',
  'batch_create_campaigns',
  'ads_budget_pacing_pills',
  'ads_videos',
  'ads_onboarding',
  'diversity_preferences',
  'content_plan_redesign',
  'generation_playground',
  'new_churn_flow',
  'calendar_review_button',
  'ads_background_publishing',
  'ai_image_generation_credits',
  'plagiarism_credits',
  'ads_credits',
  'nextgen_content_preferences',
  'icp_block',
  'blaze_studio_live',
  'create_content_modal_v2',
  'seo_relevance_plan',
  'map_pack',
  'map_pack_post_gen',
  'map_pack_live_updates',
  'map_pack_heatmap',
  'map_pack_heatmap_prefetch',
  'map_pack_reviews',
  'vertical_plan_length',
  'facebook_stories',
  'compact_calendar_view',
  'mobile_content_plan',
  'google_ads_integration',
  'dynamic_captions',
  'global_dynamic_captions',
  'location_tagging_x',
  'location_tagging_linkedin',
  'user_tagging_x',
  'user_mentioning_x',
  'user_mentioning_linkedin',
  'location_tagging_facebook',
  'location_tagging_instagram',
  'user_mentioning_facebook',
  'user_mentioning_instagram',
  'user_tagging_instagram',
  'ads_creative_refresh',
  'meta_ads_creative_fatigue',
  'meta_ads_v3',
  'meta_ads_weekly_report',
  'fast_website_scraping',
  'learning_loop_playground',
  'learnings_screen',
  'post_content_types',
  'merged_brand_plan_settings',
  'dfy_login_cta',
  'dfy_home_cta',
  'dfy_canceled_cta',
  'dfy_product_pages',
  'auto_replies',
  'generation_v2',
  'billing_upgrades_and_add_ons',
  'billing_credits_and_plan_card',
  'activation_integration_modal',
  'duplicate_campaigns',
  'home_v4',
  'content_type_discovery',
  'strict_brand_control',
  'calendar_v2',
  'campaign_filter',
  'strategies_discount',
  'dfy_unscheduled_posts',
  'zapier_v2',
  'reputation_management',
  'reputation_customer_support_voice',
  'reputation_social_listening',
  'reputation_review_requests',
  'seo_aeo',
  'aeo_snapshots',
  'video_voiceover_captions',
  'editable_captions',
  'paid_search',
  'extract_layers',
  'competitor_analysis',
  'ai_avatar_videos',
  'strategies_migration',
  'a2p_compliance',
  'facebook_graph_api_v23',
  'hide_booking',
  'hide_meta_strategy',
  'dfy_copy_duplicate',
]

export interface FlipperOverride {
  [key: string]: boolean
}

/**
 * Returns whether the feature is enabled. Takes user-specific (localStorage) overrides and URL query overrides into account.
 * @returns boolean
 */
export const useFlipperFlag = (feature: FlaggedFeature, logImpression: boolean = false) => {
  const rootStore = useRootStore()
  const featureFlags = rootStore.featureFlags

  useEffect(() => {
    if (!logImpression) return

    // Create user_experiment record
    client.createUserExperimentImpression(feature)
  }, [logImpression, feature])

  return featureFlags.isActive(feature)
}
